import { render, staticRenderFns } from "./ContainerEdit.vue?vue&type=template&id=152c9e7c&"
import script from "./ContainerEdit.vue?vue&type=script&lang=js&"
export * from "./ContainerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports